// @flow
import React from "react"
import Link from "gatsby-link"
import injectSheet from "react-jss"

import HeroHeader from '../layouts/HeroHeader'
import TextSection from '../layouts/TextSection'
import NavBar from '../components/Navbar'
import CTASection from '../layouts/CTASection'
import Banner from '../layouts/Banner'
import FeatureSection from '../layouts/FeatureSection'
import TextImageSection from '../layouts/TextImageSection'

import { styles } from '../pagesStyles/index.Style'

type Props = {
  classes: { [string]: string }
}

const HomePage = ({ classes }: Props) =>
  <div>
    <Banner />
    <NavBar
      sticky
      whitebackground
    />
    <HeroHeader />
    <TextSection />
    <TextImageSection />
    <FeatureSection />
    <CTASection />
  </div>

export default injectSheet(styles)(HomePage)



// WEBPACK FOOTER //
// ./src/pages/index.js